import { Card } from "antd";
import styled from "styled-components";
import { Row } from "../../../components/ui/grid/row.component";
import { MdChevronRight } from "react-icons/md";
import { colors } from "../../../theme/colors";
import { Link } from "react-router-dom";
import _ from "lodash";
import { Moment } from "moment";
import { Pill } from "../../../components/ui/pill/pill.component";

export const Ticket = ({
                         id,
                         title,
                         description,
                         createdAt,
                         film,
                         status,
                       }: {
  id: string;
  title: string;
  description: string;
  createdAt: Moment;
  film?: string;
  status: "open" | "closed";
}) => {
  return (
      <Link style={{ textDecoration: "none" }} to={`/t/${id}`}>
        <Main>
          <Row $spaceApart $full>
            <Row $gap={10}>
              <Title>{title}</Title>
              <Pill
                  $pulse={status === "open"}
                  style={{
                    backgroundColor:
                        status === "open"
                            ? colors.primary.hex
                            : colors.complement.hex,
                    color: status === "open" ? colors.white.hex : colors.black.hex,
                  }}
              >
                {_.capitalize(status)}
              </Pill>
            </Row>
            <MdChevronRight size={16} color={colors.text.hex} />
          </Row>
          <Description>
            {_.truncate(description, { length: 75 })} (created on{" "}
            {createdAt.format("DD-MM-YYYY")} at {createdAt.format("HH:MM")}){" "}
            {film ? ` (${film})` : ""}
          </Description>
        </Main>
      </Link>
  );
};

const Main = styled(Card)`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 2.7rem;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: ${colors.primary.hex};
`;

const Description = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
`;
